import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgBrand = ({ title, titleId,...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: "262px",
	height: "94px",
	viewBox: "0 0 262 94",
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title === undefined ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: "5ebd771e9649dbd863d0d5b9_Logo_Stiftung_Fairchance-final"
	}) : title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("g", {
		id: "Material-Design-Stickersheet",
		stroke: "none",
		strokeWidth: 1,
		fill: "none",
		fillRule: "evenodd",
		children: /* @__PURE__ */ _jsx("g", {
			id: "Login",
			transform: "translate(-589.000000, -155.000000)",
			children: /* @__PURE__ */ _jsxs("g", {
				id: "5ebd771e9649dbd863d0d5b9_Logo_Stiftung_Fairchance-final",
				transform: "translate(589.000000, 155.000000)",
				children: [
					/* @__PURE__ */ _jsx("rect", {
						id: "Rectangle",
						x: 0,
						y: -454747351e-21,
						width: 262,
						height: 94
					}),
					/* @__PURE__ */ _jsxs("g", {
						id: "Ebene-1",
						transform: "translate(0.000000, 1.000000)",
						children: [
							/* @__PURE__ */ _jsx("g", {
								id: "Group",
								transform: "translate(18.990592, 51.382085)",
								fill: "#EC008C",
								fillRule: "nonzero",
								children: /* @__PURE__ */ _jsx("path", {
									d: "M6.50730461,12.8448749 C10.0791641,12.8448749 12.9745893,9.97002955 12.9745893,6.42276057 C12.9745893,2.87516846 10.0791641,0 6.50730461,0 C2.93544511,0 0.0400199233,2.87516846 0.0400199233,6.42276057 C0.0400199233,9.97002955 2.93544511,12.8448749 6.50730461,12.8448749",
									id: "Path"
								})
							}),
							/* @__PURE__ */ _jsx("g", {
								id: "Group",
								transform: "translate(33.361975, 16.515481)",
								fill: "#230000",
								fillRule: "nonzero",
								children: /* @__PURE__ */ _jsx("path", {
									d: "M6.50730461,12.8455211 C10.0794895,12.8455211 12.9749147,9.96970643 12.9749147,6.42276057 C12.9749147,2.87581471 10.0794895,0 6.50730461,0 C2.93577047,0 0.0400199233,2.87581471 0.0400199233,6.42276057 C0.0400199233,9.96970643 2.93577047,12.8455211 6.50730461,12.8455211",
									id: "Path"
								})
							}),
							/* @__PURE__ */ _jsx("g", {
								id: "Group",
								transform: "translate(56.531558, 16.271263)",
								fill: "#6C6E70",
								fillRule: "nonzero",
								children: /* @__PURE__ */ _jsx("path", {
									d: "M6.50730461,12.845198 C10.0794895,12.845198 12.9745893,9.96970643 12.9745893,6.42243745 C12.9745893,2.87516846 10.0794895,0 6.50730461,0 C2.93544511,0 0.0400199233,2.87516846 0.0400199233,6.42243745 C0.0400199233,9.96970643 2.93544511,12.845198 6.50730461,12.845198",
									id: "Path"
								})
							}),
							/* @__PURE__ */ _jsx("g", {
								id: "Group",
								transform: "translate(56.531558, -0.000032)",
								fill: "#EC008C",
								fillRule: "nonzero",
								children: /* @__PURE__ */ _jsx("path", {
									d: "M6.50730461,12.8455211 C10.0794895,12.8455211 12.9745893,9.96970643 12.9745893,6.42276057 C12.9745893,2.87549159 10.0794895,0 6.50730461,0 C2.93544511,0 0.0400199233,2.87549159 0.0400199233,6.42276057 C0.0400199233,9.96970643 2.93544511,12.8455211 6.50730461,12.8455211",
									id: "Path"
								})
							}),
							/* @__PURE__ */ _jsx("g", {
								id: "Group",
								transform: "translate(79.704070, 30.584548)",
								fill: "#00A4AD",
								fillRule: "nonzero",
								children: /* @__PURE__ */ _jsx("path", {
									d: "M6.50730461,12.8455211 C10.0794895,12.8455211 12.9742639,9.96970643 12.9742639,6.42276057 C12.9742639,2.87516846 10.0794895,0 6.50730461,0 C2.93544511,0 0.0400199233,2.87516846 0.0400199233,6.42276057 C0.0400199233,9.96970643 2.93544511,12.8455211 6.50730461,12.8455211",
									id: "Path"
								})
							}),
							/* @__PURE__ */ _jsx("g", {
								id: "Group",
								transform: "translate(62.028604, 38.322655)",
								fill: "#A06A29",
								fillRule: "nonzero",
								children: /* @__PURE__ */ _jsx("path", {
									d: "M6.50730461,12.845198 C10.0794895,12.845198 12.97524,9.96970643 12.97524,6.42243745 C12.97524,2.87516846 10.0794895,0 6.50730461,0 C2.93577047,0 0.0406706538,2.87516846 0.0406706538,6.42243745 C0.0406706538,9.96970643 2.93577047,12.845198 6.50730461,12.845198",
									id: "Path"
								})
							}),
							/* @__PURE__ */ _jsx("g", {
								id: "Group",
								transform: "translate(43.596989, 51.542678)",
								fill: "#B9B5BA",
								fillRule: "nonzero",
								children: /* @__PURE__ */ _jsx("path", {
									d: "M6.50730461,12.8455211 C10.0791641,12.8455211 12.9745893,9.96970643 12.9745893,6.42276057 C12.9745893,2.87549159 10.0791641,0 6.50730461,0 C2.93544511,0 0.0400199233,2.87549159 0.0400199233,6.42276057 C0.0400199233,9.96970643 2.93544511,12.8455211 6.50730461,12.8455211",
									id: "Path"
								})
							}),
							/* @__PURE__ */ _jsx("g", {
								id: "Group",
								transform: "translate(57.501797, 52.452599)",
								fill: "#00AEEF",
								fillRule: "nonzero",
								children: /* @__PURE__ */ _jsx("path", {
									d: "M6.50730461,12.845198 C10.0791641,12.845198 12.9745893,9.97002955 12.9745893,6.42276057 C12.9745893,2.87516846 10.0791641,0 6.50730461,0 C2.93511974,0 0.0396945581,2.87516846 0.0396945581,6.42276057 C0.0396945581,9.97002955 2.93511974,12.845198 6.50730461,12.845198",
									id: "Path"
								})
							}),
							/* @__PURE__ */ _jsx("g", {
								id: "Group",
								transform: "translate(97.741993, 24.030663)",
								fill: "#FAB077",
								fillRule: "nonzero",
								children: /* @__PURE__ */ _jsx("path", {
									d: "M6.50730461,12.8455211 C10.0794895,12.8455211 12.9742639,9.97002955 12.9742639,6.42276057 C12.9742639,2.87549159 10.0794895,0 6.50730461,0 C2.93544511,0 0.0396945581,2.87549159 0.0396945581,6.42276057 C0.0396945581,9.97002955 2.93544511,12.8455211 6.50730461,12.8455211",
									id: "Path"
								})
							}),
							/* @__PURE__ */ _jsx("g", {
								id: "Group",
								transform: "translate(88.544894, 22.319295)",
								fill: "#F47D25",
								fillRule: "nonzero",
								children: /* @__PURE__ */ _jsx("path", {
									d: "M6.50730461,12.8455211 C10.0794895,12.8455211 12.9742639,9.96970643 12.9742639,6.42276057 C12.9742639,2.87516846 10.0794895,0 6.50730461,0 C2.93511974,0 0.0403452886,2.87516846 0.0403452886,6.42276057 C0.0403452886,9.96970643 2.93511974,12.8455211 6.50730461,12.8455211",
									id: "Path"
								})
							}),
							/* @__PURE__ */ _jsx("g", {
								id: "Group",
								transform: "translate(14.656077, 34.682649)",
								fill: "#6C6E70",
								fillRule: "nonzero",
								children: /* @__PURE__ */ _jsx("path", {
									d: "M6.50730461,12.8455211 C10.0788387,12.8455211 12.9742639,9.97002955 12.9742639,6.42276057 C12.9742639,2.87581471 10.0788387,0 6.50730461,0 C2.93544511,0 0.0400199233,2.87581471 0.0400199233,6.42276057 C0.0400199233,9.97002955 2.93544511,12.8455211 6.50730461,12.8455211",
									id: "Path"
								})
							}),
							/* @__PURE__ */ _jsx("g", {
								id: "Group",
								transform: "translate(42.303662, 3.639230)",
								fill: "#FAB077",
								fillRule: "nonzero",
								children: /* @__PURE__ */ _jsx("path", {
									d: "M6.50730461,12.8458443 C10.0791641,12.8458443 12.9745893,9.97002955 12.9745893,6.4230837 C12.9745893,2.87581471 10.0791641,0 6.50730461,0 C2.93511974,0 0.0400199233,2.87581471 0.0400199233,6.4230837 C0.0400199233,9.97002955 2.93511974,12.8458443 6.50730461,12.8458443",
									id: "Path"
								})
							}),
							/* @__PURE__ */ _jsx("g", {
								id: "Group",
								transform: "translate(4.276763, 18.690922)",
								fill: "#FFF200",
								fillRule: "nonzero",
								children: /* @__PURE__ */ _jsx("path", {
									d: "M6.50730461,12.845198 C10.0791641,12.845198 12.9745893,9.96970643 12.9745893,6.42276057 C12.9745893,2.87516846 10.0791641,0 6.50730461,0 C2.93544511,0 0.0400199233,2.87516846 0.0400199233,6.42276057 C0.0400199233,9.96970643 2.93544511,12.845198 6.50730461,12.845198",
									id: "Path"
								})
							}),
							/* @__PURE__ */ _jsx("g", {
								id: "Group",
								transform: "translate(75.286911, 48.812916)",
								fill: "#230000",
								fillRule: "nonzero",
								children: /* @__PURE__ */ _jsx("path", {
									d: "M6.50730461,12.8455211 C10.0788387,12.8455211 12.9742639,9.97002955 12.9742639,6.42276057 C12.9742639,2.87516846 10.0788387,0 6.50730461,0 C2.93511974,0 0.0393691929,2.87516846 0.0393691929,6.42276057 C0.0393691929,9.97002955 2.93511974,12.8455211 6.50730461,12.8455211",
									id: "Path"
								})
							}),
							/* @__PURE__ */ _jsx("g", {
								id: "Group",
								transform: "translate(71.406606, 3.425612)",
								fill: "#FFF200",
								fillRule: "nonzero",
								children: /* @__PURE__ */ _jsx("path", {
									d: "M6.50730461,12.8455211 C10.0788387,12.8455211 12.9749147,9.96970643 12.9749147,6.42276057 C12.9749147,2.87549159 10.0788387,0 6.50730461,0 C2.93511974,0 0.0396945581,2.87549159 0.0396945581,6.42276057 C0.0396945581,9.96970643 2.93511974,12.8455211 6.50730461,12.8455211",
									id: "Path"
								})
							}),
							/* @__PURE__ */ _jsx("g", {
								id: "Group",
								transform: "translate(92.532895, 7.493242)",
								fill: "#28B34A",
								fillRule: "nonzero",
								children: /* @__PURE__ */ _jsx("path", {
									d: "M6.50730461,12.8455211 C10.0791641,12.8455211 12.9749147,9.96970643 12.9749147,6.42276057 C12.9749147,2.87549159 10.0791641,0 6.50730461,0 C2.93511974,0 0.0393691929,2.87549159 0.0393691929,6.42276057 C0.0393691929,9.96970643 2.93511974,12.8455211 6.50730461,12.8455211",
									id: "Path"
								})
							}),
							/* @__PURE__ */ _jsx("g", {
								id: "Group",
								transform: "translate(13.847870, 13.487765)",
								fill: "#F47D25",
								fillRule: "nonzero",
								children: /* @__PURE__ */ _jsx("path", {
									d: "M6.50730461,12.8455211 C10.0791641,12.8455211 12.9742639,9.96970643 12.9742639,6.42276057 C12.9742639,2.87549159 10.0791641,0 6.50730461,0 C2.93544511,0 0.0400199233,2.87549159 0.0400199233,6.42276057 C0.0400199233,9.96970643 2.93544511,12.8455211 6.50730461,12.8455211",
									id: "Path"
								})
							}),
							/* @__PURE__ */ _jsx("g", {
								id: "Group",
								transform: "translate(74.963173, 65.672622)",
								fill: "#24408E",
								fillRule: "nonzero",
								children: /* @__PURE__ */ _jsx("path", {
									d: "M6.50730461,12.8455211 C10.0794895,12.8455211 12.9749147,9.97035268 12.9749147,6.4230837 C12.9749147,2.87581471 10.0794895,0 6.50730461,0 C2.93544511,0 0.0403452886,2.87581471 0.0403452886,6.4230837 C0.0403452886,9.97035268 2.93544511,12.8455211 6.50730461,12.8455211",
									id: "Path"
								})
							}),
							/* @__PURE__ */ _jsx("g", {
								id: "Group",
								transform: "translate(98.805286, 33.878390)",
								fill: "#24408E",
								fillRule: "nonzero",
								children: /* @__PURE__ */ _jsx("path", {
									d: "M6.50730461,12.8455211 C10.0794895,12.8455211 12.9742639,9.97002955 12.9742639,6.42276057 C12.9742639,2.87549159 10.0794895,0 6.50730461,0 C2.93544511,0 0.0400199233,2.87549159 0.0400199233,6.42276057 C0.0400199233,9.97002955 2.93544511,12.8455211 6.50730461,12.8455211",
									id: "Path"
								})
							}),
							/* @__PURE__ */ _jsx("g", {
								id: "Group",
								transform: "translate(33.896224, 61.765391)",
								fill: "#A06A29",
								fillRule: "nonzero",
								children: /* @__PURE__ */ _jsx("path", {
									d: "M6.50730461,12.8455211 C10.0791641,12.8455211 12.9745893,9.96970643 12.9745893,6.42340682 C12.9745893,2.87516846 10.0791641,0 6.50730461,0 C2.93544511,0 0.0403452886,2.87516846 0.0403452886,6.42340682 C0.0403452886,9.96970643 2.93544511,12.8455211 6.50730461,12.8455211",
									id: "Path"
								})
							}),
							/* @__PURE__ */ _jsx("g", {
								id: "Group",
								transform: "translate(23.872047, 1.605512)",
								fill: "#B9B5BA",
								fillRule: "nonzero",
								children: /* @__PURE__ */ _jsx("path", {
									d: "M6.50730461,12.8455211 C10.0791641,12.8455211 12.9745893,9.97002955 12.9745893,6.4230837 C12.9745893,2.87549159 10.0791641,0 6.50730461,0 C2.93544511,0 0.0400199233,2.87549159 0.0400199233,6.4230837 C0.0400199233,9.97002955 2.93544511,12.8455211 6.50730461,12.8455211",
									id: "Path"
								})
							}),
							/* @__PURE__ */ _jsx("g", {
								id: "Group",
								transform: "translate(5.440009, 49.669198)",
								fill: "#00AEEF",
								fillRule: "nonzero",
								children: /* @__PURE__ */ _jsx("path", {
									d: "M6.50730461,12.8455211 C10.0794895,12.8455211 12.9749147,9.97002955 12.9749147,6.42276057 C12.9749147,2.87581471 10.0794895,0 6.50730461,0 C2.93544511,0 0.0400199233,2.87581471 0.0400199233,6.42276057 C0.0400199233,9.97002955 2.93544511,12.8455211 6.50730461,12.8455211",
									id: "Path"
								})
							}),
							/* @__PURE__ */ _jsx("g", {
								id: "Group",
								transform: "translate(26.182937, 31.950637) scale(-1, 1) translate(-26.182937, -31.950637) translate(19.682937, 25.450637)",
								fill: "#EC008C",
								fillRule: "nonzero",
								children: /* @__PURE__ */ _jsx("path", {
									d: "M6.50730461,0.0794888112 C2.93544511,0.0794888112 0.0400199233,2.95530353 0.0400199233,6.50224938 C0.0400199233,10.0495184 2.93544511,12.92501 6.50730461,12.92501 C10.0794895,12.92501 12.9745893,10.0495184 12.9745893,6.50224938 C12.9745893,2.95530353 10.0794895,0.0794888112 6.50730461,0.0794888112",
									id: "Path"
								})
							}),
							/* @__PURE__ */ _jsx("g", {
								id: "Group",
								transform: "translate(27.045155, 80.006793) scale(-1, 1) translate(-27.045155, -80.006793) translate(20.545155, 73.506793)",
								fill: "#230000",
								fillRule: "nonzero",
								children: /* @__PURE__ */ _jsx("path", {
									d: "M6.50762997,0.079165686 C2.93544511,0.079165686 0.0400199233,2.95530353 0.0400199233,6.50224938 C0.0400199233,10.0495184 2.93544511,12.92501 6.50762997,12.92501 C10.0791641,12.92501 12.9749147,10.0495184 12.9749147,6.50224938 C12.9749147,2.95530353 10.0791641,0.079165686 6.50762997,0.079165686",
									id: "Path"
								})
							}),
							/* @__PURE__ */ _jsx("g", {
								id: "Group",
								transform: "translate(62.075277, 70.648117) scale(-1, 1) translate(-62.075277, -70.648117) translate(55.575277, 64.148117)",
								fill: "#6C6E70",
								fillRule: "nonzero",
								children: /* @__PURE__ */ _jsx("path", {
									d: "M6.50632851,0.0788425607 C2.93446901,0.0788425607 0.0396945581,2.95530353 0.0396945581,6.50224938 C0.0396945581,10.0491952 2.93446901,12.92501 6.50632851,12.92501 C10.0785134,12.92501 12.9739386,10.0491952 12.9739386,6.50224938 C12.9739386,2.95530353 10.0785134,0.0788425607 6.50632851,0.0788425607",
									id: "Path"
								})
							}),
							/* @__PURE__ */ _jsx("g", {
								id: "Group",
								transform: "translate(57.872209, 85.902214) scale(-1, 1) translate(-57.872209, -85.902214) translate(51.372209, 79.402214)",
								fill: "#EC008C",
								fillRule: "nonzero",
								children: /* @__PURE__ */ _jsx("path", {
									d: "M6.50665388,0.079165686 C2.93479438,0.079165686 0.0396945581,2.9549804 0.0396945581,6.50192626 C0.0396945581,10.0491952 2.93479438,12.92501 6.50665388,12.92501 C10.0785134,12.92501 12.9742639,10.0491952 12.9742639,6.50192626 C12.9742639,2.9549804 10.0785134,0.079165686 6.50665388,0.079165686",
									id: "Path"
								})
							}),
							/* @__PURE__ */ _jsx("g", {
								id: "Group",
								transform: "translate(43.320900, 52.985445) scale(-1, 1) translate(-43.320900, -52.985445) translate(36.820900, 46.485445)",
								fill: "#00A4AD",
								fillRule: "nonzero",
								children: /* @__PURE__ */ _jsx("path", {
									d: "M6.50697924,0.0794888112 C2.93544511,0.0794888112 0.0400199233,2.9549804 0.0400199233,6.50192626 C0.0400199233,10.0495184 2.93544511,12.92501 6.50697924,12.92501 C10.0788387,12.92501 12.9742639,10.0495184 12.9742639,6.50192626 C12.9742639,2.9549804 10.0788387,0.0794888112 6.50697924,0.0794888112",
									id: "Path"
								})
							}),
							/* @__PURE__ */ _jsx("g", {
								id: "Group",
								transform: "translate(74.902802, 67.276305) scale(-1, 1) translate(-74.902802, -67.276305) translate(68.402802, 60.776305)",
								fill: "#00A4AD",
								fillRule: "nonzero",
								children: /* @__PURE__ */ _jsx("path", {
									d: "M6.50697924,0.0794888112 C2.93544511,0.0794888112 0.0396945581,2.9549804 0.0396945581,6.50224938 C0.0396945581,10.0498415 2.93544511,12.92501 6.50697924,12.92501 C10.0791641,12.92501 12.9745893,10.0498415 12.9745893,6.50224938 C12.9745893,2.9549804 10.0791641,0.0794888112 6.50697924,0.0794888112",
									id: "Path"
								})
							}),
							/* @__PURE__ */ _jsx("g", {
								id: "Group",
								transform: "translate(85.520445, 17.499700) scale(-1, 1) translate(-85.520445, -17.499700) translate(79.020445, 10.999700)",
								fill: "#A06A29",
								fillRule: "nonzero",
								children: /* @__PURE__ */ _jsx("path", {
									d: "M6.50795534,0.0794888112 C2.93577047,0.0794888112 0.0403452886,2.95530353 0.0403452886,6.50224938 C0.0403452886,10.0491952 2.93577047,12.92501 6.50795534,12.92501 C10.0794895,12.92501 12.9749147,10.0491952 12.9749147,6.50224938 C12.9749147,2.95530353 10.0794895,0.0794888112 6.50795534,0.0794888112",
									id: "Path"
								})
							}),
							/* @__PURE__ */ _jsx("g", {
								id: "Group",
								transform: "translate(41.416537, 38.279368) scale(-1, 1) translate(-41.416537, -38.279368) translate(34.916537, 31.779368)",
								fill: "#B9B5BA",
								fillRule: "nonzero",
								children: /* @__PURE__ */ _jsx("path", {
									d: "M6.50697924,0.0794888112 C2.93544511,0.0794888112 0.0396945581,2.95530353 0.0396945581,6.50224938 C0.0396945581,10.0491952 2.93544511,12.92501 6.50697924,12.92501 C10.0791641,12.92501 12.9745893,10.0491952 12.9745893,6.50224938 C12.9745893,2.95530353 10.0791641,0.0794888112 6.50697924,0.0794888112",
									id: "Path"
								})
							}),
							/* @__PURE__ */ _jsx("g", {
								id: "Group",
								transform: "translate(92.641389, 73.095144) scale(-1, 1) translate(-92.641389, -73.095144) translate(86.141389, 66.595144)",
								fill: "#FAB077",
								fillRule: "nonzero",
								children: /* @__PURE__ */ _jsx("path", {
									d: "M6.50665388,0.0788425607 C2.93511974,0.0788425607 0.0396945581,2.95465728 0.0396945581,6.50160313 C0.0396945581,10.0488721 2.93511974,12.92501 6.50665388,12.92501 C10.0788387,12.92501 12.9742639,10.0488721 12.9742639,6.50160313 C12.9742639,2.95465728 10.0788387,0.0788425607 6.50665388,0.0788425607",
									id: "Path"
								})
							}),
							/* @__PURE__ */ _jsx("g", {
								id: "Group",
								transform: "translate(89.885220, 63.583306) scale(-1, 1) translate(-89.885220, -63.583306) translate(83.385220, 57.083306)",
								fill: "#F47D25",
								fillRule: "nonzero",
								children: /* @__PURE__ */ _jsx("path", {
									d: "M6.50697924,0.0794888112 C2.93479438,0.0794888112 0.0396945581,2.9549804 0.0396945581,6.50192626 C0.0396945581,10.0491952 2.93479438,12.92501 6.50697924,12.92501 C10.0788387,12.92501 12.9745893,10.0491952 12.9745893,6.50192626 C12.9745893,2.9549804 10.0788387,0.0794888112 6.50697924,0.0794888112",
									id: "Path"
								})
							}),
							/* @__PURE__ */ _jsx("g", {
								id: "Group",
								transform: "translate(28.215169, 68.506766) scale(-1, 1) translate(-28.215169, -68.506766) translate(21.715169, 62.006766)",
								fill: "#6C6E70",
								fillRule: "nonzero",
								children: /* @__PURE__ */ _jsx("path", {
									d: "M6.50730461,0.0794888112 C2.93511974,0.0794888112 0.0400199233,2.95530353 0.0400199233,6.50257251 C0.0400199233,10.0498415 2.93511974,12.92501 6.50730461,12.92501 C10.0791641,12.92501 12.9745893,10.0498415 12.9745893,6.50257251 C12.9745893,2.95530353 10.0791641,0.0794888112 6.50730461,0.0794888112",
									id: "Path"
								})
							}),
							/* @__PURE__ */ _jsx("g", {
								id: "Group",
								transform: "translate(43.644639, 82.262531) scale(-1, 1) translate(-43.644639, -82.262531) translate(37.144639, 75.762531)",
								fill: "#FAB077",
								fillRule: "nonzero",
								children: /* @__PURE__ */ _jsx("path", {
									d: "M6.50762997,0.079165686 C2.93544511,0.079165686 0.0403452886,2.95465728 0.0403452886,6.50224938 C0.0403452886,10.0491952 2.93544511,12.92501 6.50762997,12.92501 C10.0791641,12.92501 12.9745893,10.0491952 12.9745893,6.50224938 C12.9745893,2.95465728 10.0791641,0.079165686 6.50762997,0.079165686",
									id: "Path"
								})
							}),
							/* @__PURE__ */ _jsx("g", {
								id: "Group",
								transform: "translate(93.658480, 42.655130) scale(-1, 1) translate(-93.658480, -42.655130) translate(87.158480, 36.155130)",
								fill: "#FFF200",
								fillRule: "nonzero",
								children: /* @__PURE__ */ _jsx("path", {
									d: "M6.50795534,0.0798119365 C2.93609584,0.0798119365 0.0403452886,2.95530353 0.0403452886,6.50257251 C0.0403452886,10.0498415 2.93609584,12.92501 6.50795534,12.92501 C10.0794895,12.92501 12.9749147,10.0498415 12.9749147,6.50257251 C12.9749147,2.95530353 10.0794895,0.0798119365 6.50795534,0.0798119365",
									id: "Path"
								})
							}),
							/* @__PURE__ */ _jsx("g", {
								id: "Group",
								transform: "translate(76.627563, 37.088652) scale(-1, 1) translate(-76.627563, -37.088652) translate(70.127563, 30.588652)",
								fill: "#230000",
								fillRule: "nonzero",
								children: /* @__PURE__ */ _jsx("path", {
									d: "M6.50730461,0.0798119365 C2.93544511,0.0798119365 0.0400199233,2.95530353 0.0400199233,6.50224938 C0.0400199233,10.0498415 2.93544511,12.92501 6.50730461,12.92501 C10.0791641,12.92501 12.9745893,10.0498415 12.9745893,6.50224938 C12.9745893,2.95530353 10.0791641,0.0798119365 6.50730461,0.0798119365",
									id: "Path"
								})
							}),
							/* @__PURE__ */ _jsx("g", {
								id: "Group",
								transform: "translate(72.746606, 82.476763) scale(-1, 1) translate(-72.746606, -82.476763) translate(66.246606, 75.976763)",
								fill: "#FFF200",
								fillRule: "nonzero",
								children: /* @__PURE__ */ _jsx("path", {
									d: "M6.50665388,0.0794888112 C2.93511974,0.0794888112 0.0396945581,2.9549804 0.0396945581,6.50192626 C0.0396945581,10.0491952 2.93511974,12.92501 6.50665388,12.92501 C10.0785134,12.92501 12.9742639,10.0491952 12.9742639,6.50192626 C12.9742639,2.9549804 10.0785134,0.0794888112 6.50665388,0.0794888112",
									id: "Path"
								})
							}),
							/* @__PURE__ */ _jsx("g", {
								id: "Group",
								transform: "translate(58.358305, 50.480578) scale(-1, 1) translate(-58.358305, -50.480578) translate(51.858305, 43.980578)",
								fill: "#28B34A",
								fillRule: "nonzero",
								children: /* @__PURE__ */ _jsx("path", {
									d: "M6.5082807,0.0794888112 C2.93609584,0.0794888112 0.0403452886,2.9549804 0.0403452886,6.50257251 C0.0403452886,10.0491952 2.93609584,12.92501 6.5082807,12.92501 C10.0801402,12.92501 12.97524,10.0491952 12.97524,6.50257251 C12.97524,2.9549804 10.0801402,0.0794888112 6.5082807,0.0794888112",
									id: "Path"
								})
							}),
							/* @__PURE__ */ _jsx("g", {
								id: "Group",
								transform: "translate(15.188521, 72.413996) scale(-1, 1) translate(-15.188521, -72.413996) translate(8.688521, 65.913996)",
								fill: "#F47D25",
								fillRule: "nonzero",
								children: /* @__PURE__ */ _jsx("path", {
									d: "M6.50730461,0.0794888112 C2.93544511,0.0794888112 0.0400199233,2.95530353 0.0400199233,6.50257251 C0.0400199233,10.0498415 2.93544511,12.92501 6.50730461,12.92501 C10.0791641,12.92501 12.9745893,10.0498415 12.9745893,6.50257251 C12.9745893,2.95530353 10.0791641,0.0794888112 6.50730461,0.0794888112",
									id: "Path"
								})
							}),
							/* @__PURE__ */ _jsx("g", {
								id: "Group",
								transform: "translate(78.371520, 22.936024) scale(-1, 1) translate(-78.371520, -22.936024) translate(71.871520, 16.436024)",
								fill: "#24408E",
								fillRule: "nonzero",
								children: /* @__PURE__ */ _jsx("path", {
									d: "M6.50600315,0.0794888112 C2.93414365,0.0794888112 0.0393691929,2.95530353 0.0393691929,6.50224938 C0.0393691929,10.0491952 2.93414365,12.92501 6.50600315,12.92501 C10.078188,12.92501 12.9739386,10.0491952 12.9739386,6.50224938 C12.9739386,2.95530353 10.078188,0.0794888112 6.50600315,0.0794888112",
									id: "Path"
								})
							}),
							/* @__PURE__ */ _jsx("g", {
								id: "Group",
								transform: "translate(30.125063, 48.364753) scale(-1, 1) translate(-30.125063, -48.364753) translate(23.625063, 41.864753)",
								fill: "#24408E",
								fillRule: "nonzero",
								children: /* @__PURE__ */ _jsx("path", {
									d: "M6.50762997,0.0794888112 C2.93577047,0.0794888112 0.0403452886,2.95530353 0.0403452886,6.50257251 C0.0403452886,10.0498415 2.93577047,12.92501 6.50762997,12.92501 C10.0794895,12.92501 12.9745893,10.0498415 12.9745893,6.50257251 C12.9745893,2.95530353 10.0794895,0.0794888112 6.50762997,0.0794888112",
									id: "Path"
								})
							}),
							/* @__PURE__ */ _jsx("g", {
								id: "Group",
								transform: "translate(51.405575, 21.835233) scale(-1, 1) translate(-51.405575, -21.835233) translate(44.905575, 15.335233)",
								fill: "#28B34A",
								fillRule: "nonzero",
								children: /* @__PURE__ */ _jsx("path", {
									d: "M6.50762997,0.0794888112 C2.93544511,0.0794888112 0.0400199233,2.9549804 0.0400199233,6.50224938 C0.0400199233,10.0495184 2.93544511,12.92501 6.50762997,12.92501 C10.0794895,12.92501 12.9749147,10.0495184 12.9749147,6.50224938 C12.9749147,2.9549804 10.0794895,0.0794888112 6.50762997,0.0794888112",
									id: "Path"
								})
							}),
							/* @__PURE__ */ _jsx("g", {
								id: "Group",
								transform: "translate(30.125063, 16.513296) scale(-1, 1) translate(-30.125063, -16.513296) translate(23.625063, 10.013296)",
								fill: "#A06A29",
								fillRule: "nonzero",
								children: /* @__PURE__ */ _jsx("path", {
									d: "M6.50762997,0.0794888112 C2.93577047,0.0794888112 0.0403452886,2.9549804 0.0403452886,6.50224938 C0.0403452886,10.0495184 2.93577047,12.92501 6.50762997,12.92501 C10.0794895,12.92501 12.9745893,10.0495184 12.9745893,6.50224938 C12.9745893,2.9549804 10.0794895,0.0794888112 6.50762997,0.0794888112",
									id: "Path"
								})
							}),
							/* @__PURE__ */ _jsx("g", {
								id: "Group",
								transform: "translate(7.027417, 49.918340) scale(-1, 1) translate(-7.027417, -49.918340) translate(0.527417, 43.418340)",
								fill: "#B9B5BA",
								fillRule: "nonzero",
								children: /* @__PURE__ */ _jsx("path", {
									d: "M6.50730461,0.0794888112 C2.93544511,0.0794888112 0.0400199233,2.9549804 0.0400199233,6.50160313 C0.0400199233,10.0495184 2.93544511,12.92501 6.50730461,12.92501 C10.0791641,12.92501 12.9745893,10.0495184 12.9745893,6.50160313 C12.9745893,2.9549804 10.0791641,0.0794888112 6.50730461,0.0794888112",
									id: "Path"
								})
							}),
							/* @__PURE__ */ _jsx("g", {
								id: "Group",
								transform: "translate(6.780693, 36.232693) scale(-1, 1) translate(-6.780693, -36.232693) translate(0.280693, 29.732693)",
								fill: "#00AEEF",
								fillRule: "nonzero",
								children: /* @__PURE__ */ _jsx("path", {
									d: "M6.50697924,0.0794888112 C2.93511974,0.0794888112 0.0400199233,2.9549804 0.0400199233,6.50224938 C0.0400199233,10.0495184 2.93511974,12.92501 6.50697924,12.92501 C10.0788387,12.92501 12.9742639,10.0495184 12.9742639,6.50224938 C12.9742639,2.9549804 10.0788387,0.0794888112 6.50697924,0.0794888112",
									id: "Path"
								})
							}),
							/* @__PURE__ */ _jsx("g", {
								id: "Group",
								transform: "translate(45.698848, 68.883841)",
								fill: "#28B34A",
								fillRule: "nonzero",
								children: /* @__PURE__ */ _jsx("path", {
									d: "M6.50730461,12.8461674 C10.0794895,12.8461674 12.9745893,9.97002955 12.9745893,6.4230837 C12.9745893,2.87581471 10.0794895,0 6.50730461,0 C2.93544511,0 0.0400199233,2.87581471 0.0400199233,6.4230837 C0.0400199233,9.97002955 2.93544511,12.8461674 6.50730461,12.8461674",
									id: "Path"
								})
							}),
							/* @__PURE__ */ _jsx("g", {
								id: "Group",
								transform: "translate(94.955890, 49.371922)",
								fill: "#00A4AD",
								fillRule: "nonzero",
								children: /* @__PURE__ */ _jsx("path", {
									d: "M6.50730461,12.8455211 C10.0785134,12.8455211 12.9742639,9.97002955 12.9742639,6.4230837 C12.9742639,2.87549159 10.0785134,0 6.50730461,0 C2.93511974,0 0.0396945581,2.87549159 0.0396945581,6.4230837 C0.0396945581,9.97002955 2.93511974,12.8455211 6.50730461,12.8455211",
									id: "Path"
								})
							}),
							/* @__PURE__ */ _jsx("g", {
								id: "Group",
								transform: "translate(57.387741, 35.162179) scale(-1, 1) translate(-57.387741, -35.162179) translate(50.887741, 28.662179)",
								fill: "#00AEEF",
								fillRule: "nonzero",
								children: /* @__PURE__ */ _jsx("path", {
									d: "M6.50795534,0.0794888112 C2.93577047,0.0794888112 0.0403452886,2.9549804 0.0403452886,6.50224938 C0.0403452886,10.0495184 2.93577047,12.92501 6.50795534,12.92501 C10.0794895,12.92501 12.9749147,10.0495184 12.9749147,6.50224938 C12.9749147,2.9549804 10.0794895,0.0794888112 6.50795534,0.0794888112",
									id: "Path"
								})
							}),
							/* @__PURE__ */ _jsx("g", {
								id: "Group",
								transform: "translate(126.823514, 27.024480)",
								fill: "#231F20",
								fillRule: "nonzero",
								children: /* @__PURE__ */ _jsx("path", {
									d: "M8.81083838,5.07619819 C8.83066277,4.91869495 8.83066277,4.52493685 8.65224329,4.11149085 C8.21610679,3.18615931 7.12576554,3.04834397 6.23366815,3.04834397 C5.7380585,3.04834397 5.44124338,3.08771978 5.22317513,3.12764248 C5.06458004,3.18615931 3.89494124,3.48147788 3.91476563,4.46587314 C3.91476563,4.62337638 3.93459001,4.93838286 4.19230704,5.19432562 C4.60861915,5.56784894 5.44124338,5.72535218 6.64998027,6.00098285 C7.34383379,6.15848609 8.03768731,6.33622412 8.71171645,6.53255628 C8.90996031,6.57193209 9.78223331,6.80818696 10.4557118,7.22163296 C12.0416627,8.18634031 12.160609,9.702309 12.160609,10.3716978 C12.160609,10.6074058 12.1209602,11.2964824 11.8632432,11.9855591 C11.6055262,12.6746358 10.793277,14.0331012 8.87031154,14.6625673 C8.0575117,14.938198 7.22488747,14.9979191 6.35316515,14.9979191 C5.77825795,14.9979191 3.45880474,15.0366375 1.83375574,13.6584842 C1.07987838,13.0290181 0.763238875,12.3399414 0.62446817,12.005247 C0.287453602,11.1586671 0.307277989,10.4302146 0.307277989,10.0960671 L3.45880474,10.0960671 C3.47862913,10.6670164 3.55792667,10.942647 3.67687299,11.178355 C4.29142897,12.4383809 6.2738676,12.3793172 6.41263831,12.3793172 C7.1852387,12.3793172 7.6213752,12.2611898 7.93856538,12.1233744 C8.75136522,11.7689922 8.94960909,11.2177308 8.94960909,10.8436606 C8.94960909,10.4695904 8.75136522,9.91832907 7.99803854,9.60332259 C7.6213752,9.42667833 7.1852387,9.34792671 6.35316515,9.15104766 C5.02493126,8.83604118 2.84424876,8.42259517 1.77428258,7.41851201 C1.37724417,7.02475391 0.763238875,6.19840878 0.763238875,4.80056752 C0.763238875,4.40626254 0.822712034,3.44210207 1.43671733,2.51677053 C2.17021963,1.39510683 3.55792667,0.469775291 6.41263831,0.469775291 C6.92752168,0.469775291 8.89013593,0.430399481 10.3367655,1.6111269 C10.5944825,1.80800595 11.1099165,2.28106256 11.4469311,3.02865607 C11.8632432,3.89492389 11.902892,4.76119171 11.9227164,5.09533921 L8.81083838,5.07619819 Z",
									id: "Path"
								})
							}),
							/* @__PURE__ */ _jsx("g", {
								id: "Group",
								transform: "translate(139.992692, 27.488026)",
								fill: "#231F20",
								fillRule: "nonzero",
								children: /* @__PURE__ */ _jsx("polygon", {
									id: "Path",
									points: "12.1149028 0.32102223 12.1149028 2.97834253 7.93250793 2.97834253 7.93250793 14.2190426 4.82062995 14.2190426 4.82062995 2.97834253 0.499464401 2.97834253 0.499464401 0.32102223"
								})
							}),
							/* @__PURE__ */ _jsx("g", {
								id: "Group",
								transform: "translate(156.402598, 34.994146) scale(-1, 1) translate(-156.402598, -34.994146) translate(154.402598, 27.494146)",
								fill: "#231F20",
								children: /* @__PURE__ */ _jsx("rect", {
									id: "Rectangle",
									x: .28359886,
									y: .315006481,
									width: 3.17135114,
									height: 13.8980203
								})
							}),
							/* @__PURE__ */ _jsx("g", {
								id: "Group",
								transform: "translate(162.166810, 27.488026)",
								fill: "#231F20",
								fillRule: "nonzero",
								children: /* @__PURE__ */ _jsx("polygon", {
									id: "Path",
									points: "10.4628706 0.32102223 10.4628706 3.03795313 3.30736846 3.03795313 3.30736846 6.06934363 9.59114826 6.06934363 9.59114826 8.6085365 3.30736846 8.6085365 3.30736846 14.2190426 0.194939799 14.2190426 0.194939799 0.32102223"
								})
							}),
							/* @__PURE__ */ _jsx("g", {
								id: "Group",
								transform: "translate(174.050297, 27.488026)",
								fill: "#231F20",
								fillRule: "nonzero",
								children: /* @__PURE__ */ _jsx("polygon", {
									id: "Path",
									points: "12.1149028 0.32102223 12.1149028 2.97834253 7.93250793 2.97834253 7.93250793 14.2190426 4.82062995 14.2190426 4.82062995 2.97834253 0.499464401 2.97834253 0.499464401 0.32102223"
								})
							}),
							/* @__PURE__ */ _jsx("g", {
								id: "Group",
								transform: "translate(188.730074, 27.743941)",
								fill: "#231F20",
								fillRule: "nonzero",
								children: /* @__PURE__ */ _jsx("path", {
									d: "M3.30406439,0.065079464 L3.30406439,9.33698899 C3.32388878,9.84887452 3.34371317,10.2426326 3.68072773,10.6949076 C4.03756669,11.1482763 4.67194705,11.5611754 5.92033271,11.5611754 C6.15877603,11.5611754 7.01067396,11.5814102 7.66487871,11.0892125 C7.74417626,11.0301488 7.9820689,10.8529577 8.1208396,10.577327 C8.14066399,10.4985754 8.21996153,10.3213842 8.23978592,10.1245052 C8.29925908,9.67168337 8.27943469,9.17948575 8.27943469,8.25470109 L8.27943469,0.065079464 L11.4111371,0.065079464 L11.4111371,8.58884859 C11.4111371,9.17948575 11.4309614,9.7898108 11.3516639,10.399589 C11.3120151,10.8529577 11.15342,11.9161046 10.2420489,12.8015134 C9.48817158,13.510278 8.18031276,14.2190426 5.88123462,14.2190426 C3.56178142,14.2190426 2.11460121,13.4517611 1.38109892,12.7818255 C1.12393257,12.5258827 0.667971685,12.0145441 0.390430276,11.1280415 C0.172362026,10.4591996 0.192186412,9.96700195 0.192186412,8.64791231 L0.192186412,0.065079464 L3.30406439,0.065079464 Z",
									id: "Path"
								})
							}),
							/* @__PURE__ */ _jsx("g", {
								id: "Group",
								transform: "translate(203.876150, 27.488026)",
								fill: "#231F20",
								fillRule: "nonzero",
								children: /* @__PURE__ */ _jsx("path", {
									d: "M3.30406439,0.32102223 L6.95120081,6.83717193 C7.40716169,7.66406394 7.88294696,8.49040907 8.29925908,9.35667689 C8.45785417,9.69137128 8.59662487,10.0260657 8.73539558,10.3410721 C8.67592242,9.63230756 8.63627365,8.92354298 8.61644926,8.19509049 C8.59662487,7.58476543 8.61644926,6.97498726 8.61644926,6.3646622 L8.61644926,0.32102223 L11.510259,0.32102223 L11.510259,14.2190426 L8.29925908,14.2190426 L4.49352757,7.4469501 C4.15651301,6.83717193 3.82004912,6.22684687 3.52213264,5.59683391 C3.20494246,4.98650885 3.08599614,4.7896298 2.86792789,4.13992893 C2.92740105,5.79371296 2.94777612,7.42780908 2.94777612,9.10128101 L2.94777612,14.2190426 L0.073240094,14.2190426 L0.073240094,0.32102223 L3.30406439,0.32102223 Z",
									id: "Path"
								})
							}),
							/* @__PURE__ */ _jsx("g", {
								id: "Group",
								transform: "translate(218.280759, 27.473136)",
								fill: "#231F20",
								fillRule: "nonzero",
								children: /* @__PURE__ */ _jsx("path", {
									d: "M9.91219318,4.7059562 C9.55535422,3.30811494 8.38626611,2.67864886 6.99855906,2.67864886 C6.66154449,2.67864886 5.78927149,2.71747779 4.95664727,3.24905123 C4.04527617,3.83968838 3.19282756,4.96189897 3.19282756,7.28507177 C3.19282756,8.95799681 3.64823777,10.0014558 4.06454988,10.572405 C4.46158829,11.1231195 5.35313499,11.9500115 7.01783277,11.9500115 C7.57291559,11.9500115 8.00905209,11.8318841 8.20729595,11.7733672 C9.57517861,11.3008575 10.1098864,10.0998953 10.2684815,9.6667614 C10.3086809,9.52894606 10.3483297,9.37144282 10.3874278,9.09581215 L6.95891029,9.09581215 L6.95891029,6.55661928 L13.0042468,6.55661928 L13.0042468,14.2338085 L11.1209301,14.2338085 C10.9821594,13.4462923 10.7448174,12.9540947 10.724993,12.1671253 C10.6456955,12.4624439 10.5069248,12.875343 9.99149072,13.3675407 C9.02009579,14.2731843 7.71168629,14.5094392 6.40382747,14.5094392 C6.02661345,14.5094392 5.51173008,14.4897513 5.17416484,14.4306875 C4.48086199,14.332248 3.11297934,14.0172415 1.86459367,12.6390882 C0.536359786,11.1630422 0.120047673,9.37144282 0.120047673,7.46171603 C0.120047673,6.95037738 0.139872059,5.71003936 0.635481718,4.3521208 C1.62670104,1.59581408 4.02545179,0.0404695827 6.95891029,0.0404695827 C8.04870086,0.0404695827 8.76237877,0.257036539 9.19851527,0.394851874 C10.2486571,0.749234166 12.2509201,1.73308253 12.9447736,4.54845296 L9.91219318,4.7059562 Z",
									id: "Path"
								})
							}),
							/* @__PURE__ */ _jsx("g", {
								id: "Group",
								transform: "translate(126.998733, 50.853859)",
								fill: "#231F20",
								fillRule: "nonzero",
								children: /* @__PURE__ */ _jsx("polygon", {
									id: "Path",
									points: "10.4628706 0.32102223 10.4628706 3.03795313 3.30736846 3.03795313 3.30736846 6.06934363 9.59059758 6.06934363 9.59059758 8.6085365 3.30736846 8.6085365 3.30736846 14.2190426 0.194939799 14.2190426 0.194939799 0.32102223"
								})
							}),
							/* @__PURE__ */ _jsx("g", {
								id: "Group",
								transform: "translate(137.587406, 51.021509)",
								fill: "#231F20",
								fillRule: "nonzero",
								children: /* @__PURE__ */ _jsx("path", {
									d: "M8.26016098,8.73650788 L6.65548704,3.00787439 L5.02933668,8.73650788 L8.26016098,8.73650788 Z M8.6764731,0.153675037 L13.2961058,14.0516954 L9.86593628,14.0516954 L9.01403834,11.2363249 L4.29583439,11.2363249 L3.42466274,14.0516954 L0.0545170625,14.0516954 L4.73252157,0.153675037 L8.6764731,0.153675037 Z",
									id: "Shape"
								})
							})
						]
					}),
					/* @__PURE__ */ _jsx("g", {
						id: "Group",
						transform: "translate(155.000000, 58.500000) scale(-1, 1) translate(-155.000000, -58.500000) translate(153.000000, 51.000000)",
						fill: "#231F20",
						children: /* @__PURE__ */ _jsx("rect", {
							id: "Rectangle",
							x: .154989939,
							y: .321708051,
							width: 3.01602044,
							height: 14.1936922
						})
					}),
					/* @__PURE__ */ _jsx("g", {
						id: "Group",
						transform: "translate(161.000000, 52.000000)",
						fill: "#231F20",
						fillRule: "nonzero",
						children: /* @__PURE__ */ _jsx("path", {
							d: "M5.44559246,6.22583271 C6.32723388,6.24593946 6.71986109,6.26604622 7.13154788,6.08508544 C7.97507015,5.7237224 8.03333799,4.75859825 8.03333799,4.53742397 C8.03333799,3.67283358 7.58244294,3.27069852 7.26877681,3.12995124 C6.91535786,2.94899047 6.50367107,2.92888371 5.72005032,2.92888371 L3.15245347,2.92888371 L3.15245347,6.22583271 L5.44559246,6.22583271 Z M5.64108923,0.234578787 C7.30798508,0.214472034 9.13116943,0.174817048 10.3074174,1.66215826 C11.0518299,2.58706891 11.1100977,3.59240657 11.1100977,4.01464838 C11.1100977,4.29614293 11.0708895,5.34169409 10.5421224,6.12529895 C10.4637059,6.24593946 10.3074174,6.46767227 10.0520191,6.70839479 C9.46389513,7.25127712 8.9939405,7.3920244 8.67972982,7.47245141 C9.28745794,7.63386395 10.3074174,7.95501348 10.6009348,9.50267496 C10.7381638,10.1667563 10.777372,11.8752718 10.8165803,12.5387947 C10.8356399,12.5589014 10.8753927,13.5234671 11.1302464,14.0266944 C11.1890588,14.1473349 11.2674754,14.2473102 11.4444571,14.4288295 L8.34700412,14.4288295 C8.32685543,14.4081642 8.20977519,14.3484025 8.15041823,14.2674169 C7.7980884,13.8658404 7.81714797,12.9610365 7.77793971,12.4985812 L7.71967187,11.3530548 C7.64071078,10.1667563 7.40600574,9.66352898 6.95456613,9.28205919 C6.3081743,8.7190701 5.56376181,8.73917686 4.01503532,8.73917686 L3.15245347,8.73917686 L3.15245347,14.4288295 L0.0947533088,14.4288295 L0.0947533088,0.234578787 L5.64108923,0.234578787 Z",
							id: "Shape"
						})
					}),
					/* @__PURE__ */ _jsx("g", {
						id: "Group",
						transform: "translate(174.000000, 51.000000)",
						fill: "#231F20",
						fillRule: "nonzero",
						children: /* @__PURE__ */ _jsx("path", {
							d: "M10.0534015,4.86695131 C10.0338532,4.74631079 9.91265384,4.34361721 9.69147901,3.98225417 C9.36921164,3.47958534 8.60571165,2.73619399 7.15802184,2.73619399 C5.89185178,2.73619399 5.16856539,3.27851781 4.78541909,3.64043937 C4.12245312,4.26374871 3.47903543,5.36906162 3.47903543,7.39984369 C3.47903543,7.8220855 3.43938034,10.2142306 5.00715245,11.4614078 C5.34840958,11.7429024 6.0325994,12.1852509 7.13847356,12.1852509 C8.78667288,12.1852509 9.55073139,11.239675 9.85289195,10.6364724 C10.0131879,10.3153229 10.0729497,9.99361485 10.1343872,9.63113477 L13.4905477,9.63113477 C13.4112375,10.2544441 13.1699559,11.7222371 11.9635477,12.9889625 C11.1386103,13.8535529 9.73169261,14.8181186 7.05804635,14.8181186 C6.27332251,14.8181186 4.28386607,14.7779051 2.5742293,13.2302436 C1.60910276,12.3656532 0.303277611,10.5767107 0.322825891,7.46072247 C0.322825891,6.51514655 0.444025231,5.52991564 0.725520472,4.62511175 C2.05201094,0.423917379 5.71089055,0.102209329 7.19879397,0.102209329 C10.354445,0.102209329 11.9635477,1.6498708 12.6265137,2.79595573 C13.1297423,3.66054612 13.2704899,4.54524326 13.3302518,4.88705806 L10.0534015,4.86695131 Z",
							id: "Path"
						})
					}),
					/* @__PURE__ */ _jsx("g", {
						id: "Group",
						transform: "translate(191.000000, 51.000000)",
						fill: "#231F20",
						fillRule: "nonzero",
						children: /* @__PURE__ */ _jsx("polygon", {
							id: "Path",
							points: "3.26735547 0.327851781 3.26735547 5.65558285 8.38348959 5.65558285 8.38348959 0.327851781 11.480398 0.327851781 11.480398 14.521544 8.38348959 14.521544 8.38348959 8.41020803 3.26735547 8.41020803 3.26735547 14.521544 0.190595736 14.521544 0.190595736 0.327851781"
						})
					}),
					/* @__PURE__ */ _jsx("g", {
						id: "Group",
						transform: "translate(205.000000, 52.000000)",
						fill: "#231F20",
						fillRule: "nonzero",
						children: /* @__PURE__ */ _jsx("path", {
							d: "M8.37783455,8.92237172 L6.74918351,3.07186507 L5.1009842,8.92237172 L8.37783455,8.92237172 Z M8.80007741,0.156944379 L13.484404,14.3506366 L10.0064856,14.3506366 L9.14133454,11.4753709 L4.35703249,11.4753709 L3.47233316,14.3506366 L0.0547351857,14.3506366 L4.79882363,0.156944379 L8.80007741,0.156944379 Z",
							id: "Shape"
						})
					}),
					/* @__PURE__ */ _jsx("g", {
						id: "Group",
						transform: "translate(221.000000, 51.000000)",
						fill: "#231F20",
						fillRule: "nonzero",
						children: /* @__PURE__ */ _jsx("path", {
							d: "M3.26735547,0.327851781 L6.87397136,6.98262856 C7.32486641,7.82711219 7.79591016,8.67103731 8.20759695,9.55573444 C8.36388546,9.89754925 8.50111439,10.2393641 8.63834332,10.5610721 C8.58007548,9.83722899 8.54086721,9.11338588 8.52126308,8.36943601 C8.50111439,7.74612666 8.52126308,7.12337583 8.52126308,6.50006648 L8.52126308,0.327851781 L11.3823774,0.327851781 L11.3823774,14.521544 L8.20759695,14.521544 L4.44360345,7.60537939 C4.11087775,6.98262856 3.77760749,6.35931921 3.48300094,5.71590311 C3.16933481,5.09259376 3.05225457,4.89152623 2.83660911,4.22800338 C2.89487695,5.91697064 2.9155702,7.58583115 2.9155702,9.29490517 L2.9155702,14.521544 L0.0724263797,14.521544 L0.0724263797,0.327851781 L3.26735547,0.327851781 Z",
							id: "Path"
						})
					}),
					/* @__PURE__ */ _jsx("g", {
						id: "Group",
						transform: "translate(235.000000, 51.000000)",
						fill: "#231F20",
						fillRule: "nonzero",
						children: /* @__PURE__ */ _jsx("path", {
							d: "M10.0534015,4.86695131 C10.0338532,4.74631079 9.91265384,4.34361721 9.69147901,3.98225417 C9.36921164,3.47958534 8.60571165,2.73619399 7.15802184,2.73619399 C5.89185178,2.73619399 5.16856539,3.27851781 4.78541909,3.64043937 C4.12245312,4.26374871 3.47903543,5.36906162 3.47903543,7.39984369 C3.47903543,7.8220855 3.43938034,10.2142306 5.00715245,11.4614078 C5.34840958,11.7429024 6.0325994,12.1852509 7.13847356,12.1852509 C8.78667288,12.1852509 9.55073139,11.239675 9.85289195,10.6364724 C10.0131879,10.3153229 10.0729497,9.99361485 10.1343872,9.63113477 L13.4905477,9.63113477 C13.4112375,10.2544441 13.1699559,11.7222371 11.9635477,12.9889625 C11.1386103,13.8535529 9.73169261,14.8181186 7.05804635,14.8181186 C6.27332251,14.8181186 4.28386607,14.7779051 2.5742293,13.2302436 C1.60910276,12.3656532 0.303277611,10.5767107 0.322825891,7.46072247 C0.322825891,6.51514655 0.444025231,5.52991564 0.725520472,4.62511175 C2.05201094,0.423917379 5.71089055,0.102209329 7.19879397,0.102209329 C10.354445,0.102209329 11.9635477,1.6498708 12.6265137,2.79595573 C13.1297423,3.66054612 13.2704899,4.54524326 13.3302518,4.88705806 L10.0534015,4.86695131 Z",
							id: "Path"
						})
					}),
					/* @__PURE__ */ _jsx("g", {
						id: "Group",
						transform: "translate(251.000000, 51.000000)",
						fill: "#231F20",
						fillRule: "nonzero",
						children: /* @__PURE__ */ _jsx("polygon", {
							id: "Path",
							points: "10.3466257 0.327851781 10.3466257 3.02159818 3.1333939 3.02159818 3.1333939 5.79633012 9.46498425 5.79633012 9.46498425 8.3292225 3.1333939 8.3292225 3.1333939 11.8076908 10.4838546 11.8076908 10.4838546 14.521544 0.0555450431 14.521544 0.0555450431 0.327851781"
						})
					})
				]
			})
		})
	})]
});
const ForwardRef = forwardRef(SvgBrand);
export { ForwardRef as ReactComponent };
